export const NATIVE_AD_ELEMENT_NAME = 'capacitor-admob-native';
export const defineNativeAdElement = (findFeed) => {
    const runtime = globalThis;
    runtime.__capacitorAdMobNativeFeedLookup = findFeed;
    if (typeof customElements === 'undefined' || customElements.get(NATIVE_AD_ELEMENT_NAME)) {
        return;
    }
    customElements.define(NATIVE_AD_ELEMENT_NAME, class extends HTMLElement {
        static get observedAttributes() {
            return ['feed-id', 'slot-key'];
        }
        connectedCallback() {
            this.connectToFeed();
        }
        disconnectedCallback() {
            this.disconnectFromFeed();
        }
        attributeChangedCallback() {
            if (!this.isConnected) {
                return;
            }
            this.disconnectFromFeed();
            this.connectToFeed();
        }
        connectToFeed() {
            var _a, _b, _c;
            const feedId = (_a = this.getAttribute('feed-id')) === null || _a === void 0 ? void 0 : _a.trim();
            const slotKey = (_b = this.getAttribute('slot-key')) === null || _b === void 0 ? void 0 : _b.trim();
            const feed = feedId ? (_c = runtime.__capacitorAdMobNativeFeedLookup) === null || _c === void 0 ? void 0 : _c.call(runtime, feedId) : undefined;
            if (!feed || !slotKey) {
                return;
            }
            try {
                feed.attach(slotKey, this);
                this.attachedFeed = feed;
            }
            catch (error) {
                this.dispatchEvent(new CustomEvent('nativeAdError', { bubbles: true, detail: error }));
            }
        }
        disconnectFromFeed() {
            var _a;
            (_a = this.attachedFeed) === null || _a === void 0 ? void 0 : _a.detach(this);
            this.attachedFeed = undefined;
        }
    });
};
export const connectNativeAdElements = () => {
    document
        .querySelectorAll(NATIVE_AD_ELEMENT_NAME)
        .forEach((element) => { var _a, _b; return (_b = (_a = element).connectToFeed) === null || _b === void 0 ? void 0 : _b.call(_a); });
};
//# sourceMappingURL=native-ad-element.js.map